import { combineReducers } from "@reduxjs/toolkit";
import { reducer as notifierReducer } from "../slices/notifier";
import { reducer as modalsReducer } from "../slices/modals";
import { reducer as authReducer } from "../slices/auth";
import { reducer as layoutReducer } from "../slices/layout";
import { reducer as projectReducer } from "../slices/project";
import { reducer as tableReducer } from "../slices/table";
import { reducer as categoriesReducer } from "../slices/categories";
import { reducer as plancomptaReducer } from "../slices/plancompta";
import { reducer as elementsReducer } from "../slices/elements";
import { reducer as objectivesReducer } from "../slices/objectives";
import { reducer as syntheseReducer } from "../slices/synthese";
import { reducer as accountsReducer } from "../slices/accounts";
import { reducer as linkingReducer } from "../slices/linking";
import { reducer as projectLockReducer } from "../slices/projectLock";
import { reducer as importedElementsReducer } from "../slices/importedElements";
import { reducer as exportsReducer } from "../slices/exports";
import { reducer as pointedSumsReducer } from "../slices/pointedSums";
import { reducer as monthEndBalanceSheetItemsReducer } from "../slices/monthEndBalanceSheetItems";

const combinedReducer = combineReducers({
  notifier: notifierReducer,
  modals: modalsReducer,
  auth: authReducer,
  layout: layoutReducer,
  project: projectReducer,
  table: tableReducer,
  categories: categoriesReducer,
  plancompta: plancomptaReducer,
  elements: elementsReducer,
  objectives: objectivesReducer,
  synthese: syntheseReducer,
  accounts: accountsReducer,
  linking: linkingReducer,
  projectLock: projectLockReducer,
  importedElements: importedElementsReducer,
  exports: exportsReducer,
  pointedSums: pointedSumsReducer,
  monthEndBalanceSheetItems: monthEndBalanceSheetItemsReducer,
});

const rootReducer = (state, action) => {
  if (action.type === "LOGOUT") {
    // check for action type
    state = undefined;
  }
  return combinedReducer(state, action);
};

export default rootReducer;
